import httpClient from '../api/httpClient'

const BASE_URL = '/refdocuments'

export const getPersonDocuments = (payload) => httpClient.get(`${BASE_URL}/${payload.deceasedId}/documents?pageSize=${payload.pageSize}&pageNumber=${payload.pageIndex}`)

export const deletePersonDocument = (payload) => 
  httpClient.delete(`${BASE_URL}/delete`, { data: { Id: payload } })

export const getDocumentsOrder = (payload) => httpClient.get(`${BASE_URL}/${payload}/alldocumentsname`)

export const saveDocumentsOrder = (payload) => httpClient.put(`${BASE_URL}/updateOrder`, payload)

export default {
    getPersonDocuments,
    deletePersonDocument,
    getDocumentsOrder,
    saveDocumentsOrder
}
